
const baseUrl = "PDEApplication";


export const pdeLoadApplicationFormUrl = (rrr) =>
    `${baseUrl}/load-pde-application-form?rrr=${rrr}`;
export const pdePersonalDetailsFormUrl = () =>
    `${baseUrl}/add-or-update-pde-application-personal-details`;
export const pdeProgrammeInfoFormUrl = () =>
    `${baseUrl}/add-or-update-pde-application-programme-details`;
export const pdeEducationInfoFormUrl = () =>
    `${baseUrl}/add-or-update-pde-education-history`;
export const pdeCertificateDetailsFormUrl = () =>
    `${baseUrl}/add-or-update-pde-application-certificate-details`;
export const pdeOLevelDetailsFormUrl = () =>
    `${baseUrl}/add-or-update-pde-application-olevel-details`;

export const pdeNCEDetailsFormUrl = () =>
    `${baseUrl}/add-or-update-nce-result`;